export default {
    methods: {
        /**
         * Succes toast
         *
         * @param   {object}  message  Toast message
         *
         */
        toastSuccess(message) {
            this.$toasted.global.toast_success({
                ...message,
            });
        },

        /**
         * Error toast
         *
         * @param   {object}  message  Toast message
         *
         */
        toastError(message) {
            this.$toasted.global.toast_error({
                ...message,
            });
        },

        /**
         * Info toast
         *
         * @param   {object}  message  Toast message
         *
         */
        toastInfo(message) {
            this.$toasted.global.toast_info({
                ...message,
            });
        },

        /**
         * Message toast
         *
         * @param   {object}  message  Toast message
         *
         */
        toastMessage(message) {
            this.$toasted.global.toast_message({
                ...message,
            });
        },
    },
};
